// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"clearfix_clearfix__3E_Hy"};